export default "__VITE_ASSET__BgLg1V96__"